import { Component } from '@angular/core';
import { ActionEvent, TableConfig } from 'ngx-aur-mat-table';

interface Unit { id: number; name: string; status: string; }

@Component({
  selector: 'app-table-row-link',
  standalone: false,
  templateUrl: './table-row-link.component.html',
})
export class TableRowLinkComponent {
  lastAction: string | null = null;

  cfg: TableConfig<Unit> = {
    columnsCfg: [
      { key: 'name', name: 'Название', valueConverter: u => u.name },
      { key: 'status', name: 'Статус', valueConverter: u => u.status },
    ],
    selectionCfg: {},
    actionCfg: { actions: [{ action: () => 'delete', icon: { name: () => 'delete', tooltip: () => 'Удалить' } }] },
    bodyRowCfg: {
      rowLinkCfg: {
        routerLink: row => ['/rl-detail', row.rowSrc.id],
        state: row => ({ name: row.rowSrc.name }),
      },
    },
  };

  data: Unit[] = [
    { id: 101, name: 'Альфа', status: 'active' },
    { id: 102, name: 'Браво', status: 'idle' },
    { id: 103, name: 'Чарли', status: 'active' },
  ];

  onAction(e: ActionEvent<Unit>): void {
    // действие НЕ навигирует — только эмит
    this.lastAction = `${e.action} #${e.value.id}`;
  }
}
